<template>
  <div>
    <q-tabs 
      v-model="nodeTab" 
      shrink stretch dense
      align="left">
      <div class="q-pl-sm q-pr-sm" style="background:#B2DFDB;color:#00695C;height:100%;display:flex;align-items:center;">
        <b>
          <q-icon name="sms" size="xs"/>
          노드
          </b>
      </div>
      <keep-alive
        v-for="(tab, idx) in tabItems"
        :key="idx" >
        <q-tab
          :name="tab.name"
          :label="tab.label"
          v-on:click="tabClick(tab)">
        </q-tab>
      </keep-alive>
    </q-tabs>
    <div class="row">
      <div class="col-12">
        <q-list bordered class="rounded-borders">
          <q-expansion-item 
            dense dark default-opened
            icon="place" 
            header-class="bg-blue-grey-6 text-white"
            expand-icon-class="text-white"
            label="노드 정보" >
            <q-separator />
            <q-card class="q-pa-sm">
              <div class="row">
                <div class="col-xs-6 col-sm-6 col-md-3">
                  <c-label-text title="노드번호" :value="node.nodeNo"></c-label-text>
                </div>
                <div class="col-xs-6 col-sm-6 col-md-3">
                  <c-label-text title="노드명" :value="node.nodeTitle"></c-label-text>
                </div>
                <div class="col-xs-12 col-sm-12 col-md-4">
                  <c-label-text title="검토기간" :value="node.startStudyDate + '~' + node.endStudyDate"></c-label-text>
                </div>
              </div>
              <div class="row">
                <div class="col-xs-12 col-sm-12 col-md-6 ">
                  <c-label-text title="노드설명" :value="node.nodeDesc"></c-label-text>
                </div>
                <div class="col-xs-12 col-sm-12 col-md-6">
                  <c-label-text title="설계조건" :value="node.designConditions"></c-label-text>
                </div>
                <div class="col-xs-12 col-sm-12 col-md-6">
                  <c-label-text title="작동조건" :value="node.operatingConditions"></c-label-text>
                </div>
                <div class="col-xs-12 col-sm-12 col-md-6">
                  <c-label-text title="설계의도" :value="node.designIntent"></c-label-text>
                </div>
              </div>
            </q-card>
          </q-expansion-item>
        </q-list>
      </div>
    </div>
    <c-table
      ref="table"
      title="시나리오 목록"
      :columns="grid.columns"
      :gridHeight="grid.height"
      :data="node.hazopScenarios"
      :merge="grid.merge"
      :filtering="false"
      :columnSetting="false"
      :usePaging="false"
      :editable="editable&&!disabled"
      selection="multiple"
      rowKey="ramHazopAssessScenarioId"
      @callbackProxy="callbackProxy"
      @innerBtnClicked="innerBtnClicked"
    >
      <!-- 버튼 영역 -->
      <template slot="table-button">
        <q-btn-group outline >
          <c-btn v-if="editable&&!disabled" label="이탈추가" icon="add" @btnClicked="addRiskType" />
          <c-btn 
            v-if="editable&&!disabled" 
            :isSubmit="isSave"
            :url="saveUrl"
            :param="node.hazopScenarios"
            mappingType="PUT"
            label="저장" 
            icon="save"
            @beforeAction="saveScenario"
            @btnCallback="saveScenarioCallback" />
          <c-btn v-if="editable&&!disabled" label="삭제" icon="remove" @btnClicked="removeScenario" />
        </q-btn-group>
      </template>
      <template v-slot:customArea="{ props, col }">
        <template v-if="props.row['sopImprovementIds'] && props.row['ibmStepNames']">
          <q-chip
            v-for="(item, index) in chipDatas(props.row['sopImprovementIds'], props.row['ibmStepNames'])"
            :key="index"
            :color="item.color"
            :clickable="true"
            text-color="white"
            style="margin-bottom:4px !important;"
            @click="linkClick(item, props.row)">
            {{item.title}}
          </q-chip>
        </template>
        <template v-else>
        </template>
        <div v-if="editable && Boolean(props.row.ramHazopAssessScenarioId) && props.row.editFlag !== 'C' && !disabled">
          <q-btn-group outline class="ColumInnerBtnGroup">
            <q-btn
              icon="add"
              color="red-6"
              text-color="white"
              class="ColumInnerBtn"
              align="center"
              @click.prevent="innerBtnClicked(col, props)">
              <q-tooltip>
                개선요청등록
              </q-tooltip>
            </q-btn>
          </q-btn-group>
        </div>
      </template>
    </c-table>
    <c-dialog :param="popupOptions"></c-dialog>
  </div>
</template>

<script>
import { uid } from 'quasar'
import selectConfig from '@/js/selectConfig';
import transactionConfig from '@/js/transactionConfig';
export default {
  name: 'hazop-scenario',
  props: {
    draw: {
      type: Object,
      default: () => ({
        ramRiskAssessmentPlanId: '',  // 평가 일련번호
        processCd: '',  // 단위공정 코드
        processName: '',  // 단위공정 코드
        psiDiagramId: '',  // 도면 일련번호
        ramTechniqueCd: '',  // 평가기법 코드_HAZOP, K-PSR 구분(평가계획의 평가기법 코드 그대로 사용)
        diagramNo: '',  // 도면번호
        diagramTitle: '',  // 도면명
        nodes: [],
      }),
    },
    param: {
      type: Object,
      default: () => ({
        ramRiskAssessmentPlanId: '',
        ramStepCd: '',
      }),
    },
    disabled: {
      type: Boolean,
      default: function() {
        return false;
      }
    },
    process: {
      type: Object,
      default: () => ({
        ramRiskAssessmentPlanId: '',  // 평가 일련번호
        processCd: '',  // 단위공정 코드
        processName: '',  // 단위공정명
        ramProcessAssessStepCd: '',  // 평가진행상태
        processExplainFeature: '',  // 공정 특징 설명
        assessDeptCd: '',  // 평가 부서 코드
        assessUserId: '',  // 평가 담당자
        assessUserName: '',  // 평가 담당자
        draws: [],
      }),
    },
  },
  data() {
    return {
      nodeTab: '',
      node: {
        ramAssessNodeId: '',  // 노드 일련번호
        ramRiskAssessmentPlanId: '',  // 평가 일련번호
        ramTechniqueCd: '',  // 평가기법 코드_HAZOP, K-PSR 구분(평가계획의 평가기법 코드 그대로 사용)
        processCd: '',  // 단위공정 코드
        psiDiagramId: '',  // 도면 일련번호
        nodeNo: '',  // 노드 번호_수기입력
        nodeTitle: '',  // 노드 타이틀
        nodeDesc: '',  // 노드 설명
        designConditions: '',  // 설계조건
        operatingConditions: '',  // 작동조건
        designIntent: '',  // 설계의도
        startStudyDate: '',  // 검토 시작일
        endStudyDate: '',  // 검토 종료일
        hazopScenarios: [],
        ramMatrixId: '',
      },
      grid: {
        merge: [
          { index: 0, colName: 'deviationName' },
        ],
        columns: [
          {
            name: 'deviationName',
            field: 'deviationName',
            label: '이탈',
            align: 'center',
            style: 'width:100px',
            innerBtn: true,
            btns: [
              { label: '', icon: 'add', color: 'light-blue', value: '1', tooltip: '가능한 원인 추가 <font color="#F0F4C3"><b>(※ 관리되는 항목)</b></font>' },
              { label: '', icon: 'add', color: 'orange', value: '2', tooltip: '원인 추가' },
            ],
            sortable: false,
          },
          {
            name: 'nodeVariableDesignIntent',
            field: 'nodeVariableDesignIntent',
            label: '설계의도',
            align: 'left',
            style: 'width:200px',
            type: 'text',
            sortable: false,
            required: true,
          },
          {
            name: 'riskOccurrenceCause',
            field: 'riskOccurrenceCause',
            label: '원인',
            align: 'left',
            style: 'width:200px',
            type: 'text',
            sortable: false,
            required: true,
          },
          {
            name: 'riskOccurrenceResult',
            field: 'riskOccurrenceResult',
            label: '결과',
            align: 'left',
            style: 'width:200px',
            type: 'text',
            sortable: false,
            required: true,
          },
          {
            name: 'currentSafetyMeasures',
            field: 'currentSafetyMeasures',
            label: '현재안전조치',
            align: 'left',
            style: 'width:170px',
            type: 'text',
            sortable: false,
            required: true,
          },
          {
            name: 'before',
            field: 'before',
            label: '개선전',
            align: 'center',
            child: [
              {
                name: 'beforeFrequency',
                field: 'beforeFrequency',
                label: '빈도',
                align: 'center',
                style: 'width:40px',
                sortable: false
              },
              {
                name: 'beforeStrength',
                field: 'beforeStrength',
                label: '강도',
                align: 'center',
                style: 'width:40px',
                sortable: false
              },
              {
                name: 'beforeRisk',
                field: 'beforeRisk',
                label: '위험도',
                align: 'center',
                style: 'width:70px',
                sortable: false,
                required: true,
                type: 'proxy',
                component: () => import(`${'@/pages/ram/base/matrixPop.vue'}`)
              },
            ]
          },
          {
            name: 'after',
            field: 'after',
            label: '개선후',
            align: 'center',
            child: [
              {
                name: 'afterFrequency',
                field: 'afterFrequency',
                label: '빈도',
                align: 'center',
                style: 'width:40px',
                sortable: false
              },
              {
                name: 'afterStrength',
                field: 'afterStrength',
                label: '강도',
                align: 'center',
                style: 'width:40px',
                sortable: false
              },
              {
                name: 'afterRisk',
                field: 'afterRisk',
                label: '위험도',
                align: 'center',
                style: 'width:70px',
                sortable: false,
                required: true,
                type: 'proxy',
                component: () => import(`${'@/pages/ram/base/matrixPop.vue'}`)
              },
            ]
          },
          {
            name: 'assessDate',
            field: 'assessDate',
            label: '평가일',
            align: 'center',
            type: 'date',
            style: 'width:100px',
            sortable: false,
            required: true,
          },
          {
            name: 'assessUserName',
            field: 'assessUserName',
            label: '평가자',
            align: 'center',
            type: 'user',
            userId: 'assessUserId',
            style: 'width:80px',
            sortable: false,
            required: true,
          },
          {
            name: 'riskbookFlag',
            field: 'riskbookFlag',
            label: '위험등록부',
            align: 'center',
            style: 'width:90px',
            sortable: true,
            type: 'check',
            'true': 'Y',
            'false': 'N',
            disableTarget: 'riskRegisterFlag',
            disableCon: false
          },
          {
            name: 'impr',
            field: 'impr',
            label: '개선진행',
            align: 'center',
            child: [
              {
                name: 'customCol',
                field: 'customCol',
                label: '개선번호/개선진행상태',
                align: 'center',
                style: 'width:150px',
                type: 'custom',
                sortable: false
              },
              {
                name: 'improvementMeasures',
                field: 'improvementMeasures',
                label: '개선대책',
                align: 'left',
                style: 'width:200px',
                type: 'text',
                sortable: false
              },
            ]
          },
        ],
        data: [],
        height: '550px'
      },
      colorItems: [],
      guideWordItems: [],
      requestImprRow: null,
      imprData: null,
      popupOptions: {
        target: null,
        title: '',
        visible: false,
        width: '80%',
        param: {},
        closeCallback: null,
      },
      rowIndex: 0,
      editable: true,
      isSave: false,
      listUrl: '',
      saveUrl: '',
      deleteUrl: '',
    };
  },
  computed: {
    tabItems() {
      let data = [];
      this.$_.forEach(this.draw.nodes, node => {
        data.push({
          name: node.ramAssessNodeId,
          label: node.nodeTitle + ' (' + node.nodeNo + ')',
          node: node,
        })
      })
      return data;
    },
  },
  beforeCreate() {},
  created() {},
  beforeMount() {
    Object.assign(this.$data, this.$options.data());
  },
  mounted() {
    this.init();
  },
  beforeDestroy() {
  },
  methods: {
    init() {
      // role setting
      this.editable = this.$route.meta.editable;
      // url setting
      this.listUrl = selectConfig.ram.hazop.scenario.list.url
      this.saveUrl = transactionConfig.ram.hazop.scenario.save.url
      this.deleteUrl = transactionConfig.ram.hazop.scenario.delete.url
      // code setting
      this.$comm.getStepItems('IBM_STEP_CD').then(_result => {
        this.colorItems = _result
      });
      this.$comm.getComboItems('RAM_VARIABLE_GUIDEWORD_CD').then(_result => {
        this.guideWordItems = _result
      });
      // list setting
      this.nodeTab = this.draw.nodes[0].ramAssessNodeId
      this.tabClick({ node: this.draw.nodes[0] })
    },
    getList() {
      this.$http.url = this.listUrl;
      this.$http.type = 'GET';
      this.$http.param = {
        ramAssessNodeId: this.node.ramAssessNodeId,
      }
      this.$http.request((_result) => {
        this.node.hazopScenarios = _result.data;
      },);
    },
    research() {
      this.$emit('research');
    },
    tabClick(tab) {
      this.$_.extend(this.node, tab.node)
    },
    /* eslint-disable no-unused-vars */
    innerBtnClicked(col, props, btn) {
      if (col.name === 'deviationName') {
        if (btn.value === '1') {
          this.rowIndex = props.rowIndex;
          this.popupOptions.title = '가능한 원인';
          this.popupOptions.param = {
            ramVariableId: props.row.ramVariableId,
            ramVariableGuidewordCd: props.row.ramVariableGuidewordCd,
            deviationName: props.row.deviationName,
          };
          this.popupOptions.target = () => import(`${'@/pages/ram/base/hazopCausePop.vue'}`);
          this.popupOptions.width = '45%';
          this.popupOptions.visible = true;
          this.popupOptions.closeCallback = this.closeCausePopup;
        } else {
          this.node.hazopScenarios.splice(props.rowIndex, 0, {
            ramHazopAssessScenarioId: uid(),
            ramAssessNodeId: this.node.ramAssessNodeId,
            ramVariableGuidewordId: props.row.ramVariableGuidewordId, 
            ramVariableId: props.row.ramVariableId,
            ramVariableGuidewordCd: props.row.ramVariableGuidewordCd,
            deviationName: props.row.deviationName, 
            nodeVariableDesignIntent: '', 
            riskOccurrenceCause: '', 
            riskOccurrenceResult: '',
            currentSafetyMeasures: '', 
            beforeRamMatrixRiskId: '',  // 전 위험도 no
            afterRamMatrixRiskId: '',  // 후 위험도 no
            improvementMeasures: '',  // 개선대책_개선요청과 별개로 수기 입력
            assessDate: this.$comm.getToday(),
            assessUserName: this.$_.clone(this.process.assessUserName),
            assessUserId: this.$_.clone(this.process.assessUserId),
            riskbookFlag: 'N', 
            sopImprovementIds: '', 
            ibmStepNames: '', 
            editFlag: 'C',
            ramMatrixId: this.node.ramMatrixId,
            // 위험등록부 등재를 위한 prop
            ramRiskAssessmentPlanId: this.node.ramRiskAssessmentPlanId,
            processCd: this.node.processCd,
            riskRegisterFlag: false,
          });
        }
      } else if (col.name === 'customCol') {
        this.requestImprRow = props.row
        let requestContents = props.row.deviationName;
        if (props.row.riskOccurrenceCause) {
          requestContents += ' / ' + props.row.riskOccurrenceCause
        }
        this.popupOptions.title = '개선 요청';
        this.popupOptions.param = {
          requestContents: requestContents,
          relationTableKey: props.row.ramHazopAssessScenarioId,
          ibmTaskTypeCd: 'ITT0000001',
        };
        this.popupOptions.target = () => import(`${'@/pages/sop/ibm/imprRequest.vue'}`);
        this.popupOptions.width = '90%';
        this.popupOptions.visible = true;
        this.popupOptions.closeCallback = this.closeAddImprPopup;
      }
    },
    closeCausePopup(data) {
      this.popupOptions.target = null;
      this.popupOptions.visible = false;

      if (data && data.length > 0) {
        this.$_.forEach(data, item => {
          this.node.hazopScenarios.splice(this.rowIndex, 0, {
            ramHazopAssessScenarioId: uid(),
            ramAssessNodeId: this.node.ramAssessNodeId,
            ramVariableId: item.ramVariableId,
            ramVariableGuidewordCd: item.ramVariableGuidewordCd,
            ramVariableGuidewordId: item.ramVariableGuidewordId, 
            deviationName: item.deviationName, 
            nodeVariableDesignIntent: '', 
            riskOccurrenceCause: item.causeName, 
            riskOccurrenceResult: '',
            currentSafetyMeasures: '', 
            beforeRamMatrixRiskId: '',  // 전 위험도 no
            afterRamMatrixRiskId: '',  // 후 위험도 no
            improvementMeasures: '',  // 개선대책_개선요청과 별개로 수기 입력
            assessDate: this.$comm.getToday(),
            assessUserName: this.$_.clone(this.process.assessUserName),
            assessUserId: this.$_.clone(this.process.assessUserId),
            riskbookFlag: 'N', 
            sopImprovementIds: '', 
            ibmStepNames: '', 
            editFlag: 'C',
            ramMatrixId: this.node.ramMatrixId,
            // 위험등록부 등재를 위한 prop
            ramRiskAssessmentPlanId: this.node.ramRiskAssessmentPlanId,
            processCd: this.node.processCd,
            riskRegisterFlag: false,
          });
        });
      }
    },
    closeAddImprPopup(data) {
      this.popupOptions.target = null;
      this.popupOptions.visible = false;

      if (data && data.length > 0) {
        this.$_.forEach(data, item => {
          let sData = this.requestImprRow.sopImprovementIds ? this.requestImprRow.sopImprovementIds : '';
          if (sData.indexOf(item.sopImprovementId) === -1) {
            this.requestImprRow.sopImprovementIds = this.requestImprRow.sopImprovementIds ? 
              this.requestImprRow.sopImprovementIds + ',' + item.sopImprovementId : item.sopImprovementId
            this.requestImprRow.ibmStepNames = this.requestImprRow.ibmStepNames ? 
              this.requestImprRow.ibmStepNames + ',' + item.ibmStepName : item.ibmStepName
          }
        })
        this.$refs['table'].$refs['compo-table'].resetVirtualScroll();
        this.research();
      }
    },
    linkClick(data, row) {
      this.requestImprRow = row
      this.imprData = data;
      this.popupOptions.title = '개선';
      this.popupOptions.param = {
        sopImprovementId: data.sopImprovementId,
      };
      this.popupOptions.target = () => import(`${'@/pages/sop/ibm/imprDetail.vue'}`);
      this.popupOptions.width = '90%';
      this.popupOptions.visible = true;
      this.popupOptions.closeCallback = this.closeImprPopup;
    },
    closeImprPopup(result) {
      this.popupOptions.target = null;
      this.popupOptions.visible = false;
      if (result && result.col1) {
        if (result.col1.ibmStepCd === 'IS00000010' || result.col1.ibmStepCd === 'IS00000015' || result.col1.ibmStepCd === 'IS00000020') {
          this.requestImprRow.riskRegisterFlag = true
        }
        let splitId = this.$_.split(this.requestImprRow.sopImprovementIds, ',');
        let splitStep = this.$_.split(this.requestImprRow.ibmStepNames, ',');
        if (splitId && splitId.length > 0) {
          let idIndex = this.$_.indexOf(splitId, result.col1.sopImprovementId);
          splitStep[idIndex] = result.col1.ibmStepName;
          this.requestImprRow.ibmStepNames = splitStep.toString();
        }
        this.$refs['table'].$refs['compo-table'].resetVirtualScroll();
        this.research();
      }
    },
    /* eslint-disable no-unused-vars */
    callbackProxy(data, props, col) {
      if (col.name === 'beforeRisk') {
        this.$set(this.node.hazopScenarios[props.rowIndex], 'beforeFrequency', data.f)
        this.$set(this.node.hazopScenarios[props.rowIndex], 'beforeStrength', data.s)
        this.$set(this.node.hazopScenarios[props.rowIndex], 'beforeRisk', data.r)
        this.$set(this.node.hazopScenarios[props.rowIndex], 'beforeRamMatrixRiskId', data.ramMatrixRiskId)
      } else {
        this.$set(this.node.hazopScenarios[props.rowIndex], 'afterFrequency', data.f)
        this.$set(this.node.hazopScenarios[props.rowIndex], 'afterStrength', data.s)
        this.$set(this.node.hazopScenarios[props.rowIndex], 'afterRisk', data.r)
        this.$set(this.node.hazopScenarios[props.rowIndex], 'afterRamMatrixRiskId', data.ramMatrixRiskId)
      }
      if (this.node.hazopScenarios[props.rowIndex].editFlag !== 'C') {
        this.$set(this.node.hazopScenarios[props.rowIndex], 'editFlag', 'U')
      }
    },
    addRiskType() {
      this.popupOptions.title = '가이드워드';
      this.popupOptions.param = {
        guideWordItems: this.guideWordItems,
        data: this.node.hazopScenarios,
        node: this.node
      };
      this.popupOptions.target = () => import(`${'@/pages/ram/base/hazopGuidewordPop.vue'}`);
      this.popupOptions.width = '80%';
      this.popupOptions.visible = true;
      this.popupOptions.closeCallback = this.closeRiskTypePopup;
    },
    closeRiskTypePopup(data) {
      this.popupOptions.target = null;
      this.popupOptions.visible = false;

      if (data && data.length > 0) {
        this.$_.forEach(data, item => {
          this.$_.forEach(this.guideWordItems, gw => {
            let name = item.variableName + ' - ' + gw.codeName;
            let index = this.$_.findIndex(this.node.hazopScenarios, { deviationName: name });
            if (item[gw.code] === 'Y' && index === -1) {
              this.node.hazopScenarios.splice(0, 0, {
                ramHazopAssessScenarioId: uid(),
                ramAssessNodeId: this.node.ramAssessNodeId,
                ramVariableId: item.ramVariableId,
                ramVariableGuidewordCd: gw.code,
                ramVariableGuidewordId: item[gw.code + '_id'], 
                deviationName: name, 
                nodeVariableDesignIntent: '', 
                riskOccurrenceCause: '', 
                riskOccurrenceResult: '',
                currentSafetyMeasures: '', 
                beforeRamMatrixRiskId: '',  // 전 위험도 no
                afterRamMatrixRiskId: '',  // 후 위험도 no
                improvementMeasures: '',  // 개선대책_개선요청과 별개로 수기 입력
                assessDate: this.$comm.getToday(),
                assessUserName: this.$_.clone(this.process.assessUserName),
                assessUserId: this.$_.clone(this.process.assessUserId),
                riskbookFlag: 'N', 
                sopImprovementIds: '', 
                ibmStepNames: '', 
                editFlag: 'C',
                ramMatrixId: this.node.ramMatrixId,
                // 위험등록부 등재를 위한 prop
                ramRiskAssessmentPlanId: this.node.ramRiskAssessmentPlanId,
                processCd: this.node.processCd,
                riskRegisterFlag: false,
              });
            } else if (item[gw.code] === 'N' && index > -1) {
              this.node.hazopScenarios = this.$_.reject(this.node.hazopScenarios, { deviationName: name })
            }
          })
        });
        let checkLists = [];
        this.$_.forEach(this.guideWordItems, gw => {
          let filterData = this.$_.filter(data, (item) => {
            return item[gw.code] === 'Y'
          });
          this.$_.forEach(filterData, fd => {
            checkLists.push(fd.variableName + ' - ' + gw.codeName)
          })
        });
        let deleteLists = [];
        this.$_.forEach(this.node.hazopScenarios, gridItem => {
          let index = this.$_.indexOf(checkLists, gridItem.deviationName);
          if (index === -1) {
            deleteLists.push(gridItem.deviationName)
          }
        });
        if (deleteLists && deleteLists.length > 0) {
          this.$_.forEach(deleteLists, deleteItem => {
            this.node.hazopScenarios = this.$_.reject(this.node.hazopScenarios, { deviationName: deleteItem })
          })
        }
      }
    },
    chipDatas(sopImprovementIds, ibmStepNames) {
      let returnData = [];
      let splitId = this.$_.split(sopImprovementIds, ',');
      let splitStep = this.$_.split(ibmStepNames, ',');

      if (splitId.length === splitStep.length) {
        let i = 0;
        this.$_.forEach(splitId, item => {
          let color = this.$_.find(this.colorItems, { stepperMstNm: splitStep[i] });
          returnData.push({
            title: item + ' / ' + splitStep[i],
            color: color ? color.colorClass : '',
            sopImprovementId: item,
          });
          i++;
        });
      }
      return returnData;
    },
    saveScenario() {
      if (this.$comm.validTable(this.grid.columns, this.node.hazopScenarios)) {
        window.getApp.$emit('CONFIRM', {
          title: '확인',
          message: '저장하시겠습니까?',
          // TODO : 필요시 추가하세요.
          type: 'info', // success / info / warning / error
          // 확인 callback 함수
          confirmCallback: () => {
            this.$_.forEach(this.node.hazopScenarios, item => {
              item.regUserId = this.$store.getters.user.userId
              item.chgUserId = this.$store.getters.user.userId
            })
            
            this.isSave = !this.isSave
          },
          // 취소 callback 함수
          cancelCallback: () => {
          },
        });
      }
    },
    saveScenarioCallback() {
      window.getApp.$emit('APP_REQUEST_SUCCESS');
      this.research();
      this.getList();
    },
    removeScenario() {
      let selectData = this.$refs['table'].selected;
      if (!selectData || selectData.length === 0) {
        window.getApp.$emit('ALERT', {
          title: '안내', // 안내
          message: '하나 이상 선택하세요.', // 하나 이상 선택하세요.
          type: 'warning', // success / info / warning / error
        });
      } else {
        window.getApp.$emit('CONFIRM', {
          title: '확인',
          message: '삭제하시겠습니까?',
          // TODO : 필요시 추가하세요.
          type: 'info', // success / info / warning / error
          // 확인 callback 함수
          confirmCallback: () => {
            this.$http.url = this.deleteUrl;
            this.$http.type = 'DELETE';
            this.$http.param = {
              data: Object.values(selectData),
            };
            this.$http.request(() => {
              window.getApp.$emit('APP_REQUEST_SUCCESS');
              this.$_.forEach(selectData, item => {
                this.node.hazopScenarios.splice(this.$_.findIndex(this.node.hazopScenarios, item), 1)
              })
              this.$refs['table'].$refs['compo-table'].clearSelection();

              // this.getList();
            },);
          },
          // 취소 callback 함수
          cancelCallback: () => {
          },
        });
      }
    },
  }
};
</script>
<style lang="sass">
.scenario-chip i 
  margin-right: -0.2em !important
</style>